import { render, staticRenderFns } from "./GitHubCard.vue?vue&type=template&id=192a381e&scoped=true"
import script from "./GitHubCard.vue?vue&type=script&lang=js"
export * from "./GitHubCard.vue?vue&type=script&lang=js"
import style0 from "./GitHubCard.vue?vue&type=style&index=0&id=192a381e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192a381e",
  null
  
)

export default component.exports